import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import HulpmiddelList from './HulpmiddelList';
import useResponsive from '../../hooks/useResponsive';
import { Tool } from '../../interfaces/TaskOverview'


interface HulpmiddelSectionProps {
    tool: Tool[];
    setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

const HulpmiddelSection: React.FC<HulpmiddelSectionProps> = ({ tool, setIsLoading }) => {

    const { isMobile, isTablet, isExceedsHulp, isDesktop } = useResponsive();
    const theme = useTheme();

    return (
        <Box
            sx={{
                width: isMobile || isTablet ? '100%' : 484,
                maxWidth: isTablet || isMobile ? '100%' : 484,
                minHeight: isMobile ? 45 : 48,
                borderRadius: 2,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: '#2B2A5C',
                pl: 2,
                pr: 2,
                pt: 0.5,
                pb: 0.5,
                mb: isMobile ? 2 : null,
                ml: isMobile ? 2 : null,
                mr: isMobile ? 2 : null,
                boxShadow: "4px 0px 20px 0px #EEEEEE80, 0px 4px 4px 0px #00000040",
                overflow: 'hidden',
            }}
        >
            <Typography
                fontFamily={isTablet || isMobile ? "Nunito Sans Regular700" : "Nunito Sans SemiBold"}
                fontSize={isMobile ? '16px' : '22px'}
                lineHeight={isMobile ? '21.82px' : '32.74px'}
                sx={{
                    color: theme.palette.secondary.main,
                    minWidth: isMobile ? null : 150,
                    whiteSpace: 'nowrap',
                    mr: isMobile ? 2 : null
                }}
            >
                Hulpmiddel
            </Typography>

            <Box
                sx={{
                    flexGrow: 1,
                    borderRadius: 1,
                    p: 1
                }}
            >
                <HulpmiddelList data={tool} loader={setIsLoading} />
            </Box>
        </Box>
    );
};

export default HulpmiddelSection;